import { Link } from "react-router-dom";
import Seo from "@/components/np/Seo";
import BookButton from "@/components/np/BookButton";
import { meta } from "@/content";

export default function NotFound() {
  return (
    <section className="container-np py-28" data-testid="not-found">
      <Seo {...meta.notFound} />
      <p className="eyebrow">404</p>
      <h1 className="mt-4 font-serif text-5xl text-ink sm:text-6xl">Sidan hittades inte</h1>
      <p className="mt-4 text-muted">Sidan du söker finns inte eller har flyttats.</p>
      <div className="mt-8 flex flex-wrap gap-4">
        <BookButton testId="notfound-book-button" />
        <Link to="/" className="link-arrow" data-testid="notfound-home-link">Till startsidan</Link>
      </div>
    </section>
  );
}
